import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
const host = process.env.REACT_APP_API_SERVER

function GoogleMeetStatus() {
  const [loading, setLoading] = useState(true);
  const [tokenStatus, setTokenStatus] = useState(null);

  const {
    ProfileDataListApiData,
    loadingProfileDataListApi,
    ProfileDataListApiError,
} = useSelector(state => state?.MasterReducer);


  const handleGoogleSignIn = () => {
    const currentUrl = window.location.href; 
    window.location.href = `${host}/api/web/google/auth/start?tutorId=${ProfileDataListApiData?.data?.id}&redirectUrl=${encodeURIComponent(currentUrl)}`;
};

  useEffect(() => {
    async function checkToken() {
      try {
        const authToken = localStorage.getItem('tutor-token');

        const res = await axios.get(`${host}/api/web/check-google-token`, {
          headers: {
            "x-auth-token": authToken,  
          },
        });

        const data = await res.data;
        setTokenStatus({ valid: data.valid, message: 'Please sign in with Google.' });
      } catch (err) {
        console.log('er',err)
        setTokenStatus({ valid: false, message: 'Please sign in with Google.' });
      } finally {
        setLoading(false);
      }
    }

    checkToken();
  }, []);

  if (loading) {
    return <div>Checking Google Calendar access...</div>;
  }

  if (!tokenStatus?.valid) {
    return (
      <div className="alert alert-danger py-2">
        {tokenStatus.message} <br />
        <button className="btn btn-sm btn-danger mt-2" onClick={handleGoogleSignIn}>
          Sign in with Google
        </button>
      </div>
    );
  }

  return (
    <div className="alert alert-success py-2">
      Signed in as <b>{ProfileDataListApiData?.data?.google_email}</b> — You can create Google Meet links.
    </div>
  );
}

export default GoogleMeetStatus;
